export default {
    /**
     *
     * Base Config
     *
     */
    /** (required) Backend server url */
    baseUrl: null,

    /** (required) Database name */
    namespaceKeyName: 'namespace',

    /** (required) Namespace ex) mzc, nexon, gram ... etc */
    namespace: null,

    /** (required) Service-Group-Name */
    serviceGroupKeyName: 'service-group',

    /** (required) Service-Group-Name that match the role and right */
    serviceGroup: null,

    /** (required) ServiceIdx */
    serviceIdx: null,

    /** (required) ServiceIdx */
    serviceIdxKeyName: 'service',

    /** (required) Local storage language key name */
    storageLanguageKeyName: 'locale',

    /** (required) Common header language key name */
    languageKeyName: 'Accept-Language',

    /** (required) Local storage token key name (excluding Auth-Server) */
    storageTokenKeyName: 'x-auth-token',

    /** (required) Common header token key name (excluding Auth-Server) */
    tokenKeyName: 'x-auth-token',

    /**
     *
     *  Use Specific Server Option (Required)
     *
     */
    /** (optional) Specific-Server Random Keys */
    specificKey: ['WmZq4t6weShVmYq3', 's6v8y/B?Xp2s5v8x', 'v9y/B?E(2s5v8y/A'],

    /** (optional) Specific auth key name list for validate */
    availableSpecificAuthKeyNames: ['hyper-auth', 'user-auth-resource', 'ri-auth', 'sp-auth'],

    /** (optional) Specific-Server's auth key name. ex) ca-auth, sp-auth, ri-auth... etc */
    specificAuthKeyName: null
}
